import { Controller, Application } from 'stimulus';

class TextInputController extends Controller {
  static targets = ['input', 'iconBtn'];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly iconBtnTarget: HTMLInputElement;

  initialize() {
    this.toggleIconVisibility();
    this.initElementsEventListeners();
  }

  clear(e: Event): void {
    e.preventDefault();
    this.inputTarget.value = '';
    this.toggleIconVisibility();
    this.inputTarget.focus();
  }

  private toggleIconVisibility() {
    this.iconBtnTarget.style.visibility = this.inputTarget.value ? 'visible' : 'hidden';
  }

  private initElementsEventListeners() {
    this.inputTarget.addEventListener('input', () => {
      this.toggleIconVisibility();
    });

    // To prevent unnecessary validation, this declaration prevent raising focusout event on input element
    this.iconBtnTarget.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });
  }
}

export function registerTextInput(application: Application): void {
  application.register('textInput', TextInputController);
}
